import { render, staticRenderFns } from "./DivorcePropertyPage.vue?vue&type=template&id=0f301199&scoped=true"
import script from "./DivorcePropertyPage.vue?vue&type=script&lang=js"
export * from "./DivorcePropertyPage.vue?vue&type=script&lang=js"
import style0 from "./DivorcePropertyPage.vue?vue&type=style&index=0&id=0f301199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f301199",
  null
  
)

export default component.exports